<script setup lang="ts">
import { bookingGlobalPopupStore } from "@/components/booking/bookingGlobalPopupStore";
import BookingConfirmDialog from "@/components/booking/bookingConfirmDialog.vue";
import BookingStepper from "@/components/booking/bookingStepper.vue";
import { storeToRefs } from "pinia";
const {
  getUserList,
  closeDialog,
  handleRefetchingData,
  showBookingConfirmDialog,
  handleReferrerUpdate,
  acceptTermsAndConditions,
  declineTermsAndConditions,
} = bookingGlobalPopupStore()

const {
  isBookingStepperVisible,
  showTermsConditionsDialog,
  editBookingData,
  recurringDetails,
  activityList,
  listArea,
  usersList,
  locationList,
  currentLocation,
  getMyRole,
  userInfo,
  userId,
  globalSetup,
  permissionListMap, isEditing,
  isBookingConfirmDialogVisible,
  confirmedBooking,
  referrers } = storeToRefs(bookingGlobalPopupStore())

  const confirmDeclineTerms = ref(false)
</script>
<template>
  <BookingStepper
    v-if="editBookingData"
    v-model:isDrawerOpen="isBookingStepperVisible"
    :booking="editBookingData"
    :recurring-details="recurringDetails"
    :activity-list="activityList"
    :area-list="listArea"
    :memberList="usersList"
    :location-list="locationList"
    :current-location="currentLocation"
    :current-logged-in-roles="getMyRole"
    :membership="userInfo?.expand?.membership"
    :user-id="userId"
    :permission="permissionListMap?.bookings ?? []"
    :coupon-value="globalSetup?.couponValue"
    @loadUsersList="getUserList()"
    @update:isDrawerOpen="closeDialog"
    @isEditing="isEditing=true"
    @refetchBookingData="handleRefetchingData"
    @showConfirmDialog="showBookingConfirmDialog"
    @closeDialog="closeDialog"
  />
  <BookingConfirmDialog
    v-if="isBookingConfirmDialogVisible && confirmedBooking"
    v-model="isBookingConfirmDialogVisible"
    :booking="confirmedBooking"
    :activities="activityList?.find(
      (activity: any) => activity.id === confirmedBooking?.activity,
    )"
    :referrers="referrers"
    @closeDialog="handleReferrerUpdate"
  />
  <TermsAndConditionsDialog
    :model-value="showTermsConditionsDialog"
    :htmlContent="globalSetup.generalTermsAndConditions"
    @close="showTermsConditionsDialog = false"
    @accept="acceptTermsAndConditions"
    @decline="confirmDeclineTerms = true"
  />
  <v-dialog v-model="confirmDeclineTerms" max-width="500">
    <v-card>
      <v-card-title class="text-h5">Decline Terms and Conditions</v-card-title>
      <v-card-text>Are you sure you want to decline the terms and conditions? You will not be able to proceed with the booking process and it will be canceled.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="elevated" @click="confirmDeclineTerms = false">Cancel</v-btn>
        <v-btn color="error" variant="elevated" @click="declineTermsAndConditions(); confirmDeclineTerms = false">Decline</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
